angular.module('console')
.controller('ReportsConsoleController', ['$scope', 'Report',
    function($scope, Report) {
        // related to new invitations, practices and users
        rawEventLogs = [];
        $scope.invitationsRadio = $scope.practicesRadio = $scope.usersRadio = 'day';

        // related to list of reminders
        $scope.pager = {currentPage: 1};
        $scope.itemsPerPage = 10;
        $scope.totalItems = 0;

        // pending review practices
        $scope.pendingPractices = [];


        $scope.onPageUpdate = function(){
            $scope.eventLogs = rawEventLogs
                .slice((($scope.pager.currentPage - 1) * $scope.itemsPerPage), ($scope.pager.currentPage * $scope.itemsPerPage));
        };

        $scope.toggleInvitations = function(timeType){
            Report.getInvitations({time_type: timeType }, function(success){
                $scope.invitations = success;
            });
        };

        $scope.togglePractices = function(timeType){
            Report.getPractices({time_type: timeType }, function(success){
                $scope.practices = success;
            });
        };

        $scope.toggleUsers = function(timeType){
            Report.getUsers({time_type: timeType }, function(success){
                $scope.users = success;
            });
        };


        // loading pending review practices
        Report.getPendingPractices(function(success){
            $scope.pendingPractices = success;
        });
        
        // loading invitations, practices and users
        $scope.toggleInvitations('day');
        $scope.togglePractices('day');
        $scope.toggleUsers('day');

        // loading full list of reminders and triggering slicing to the current page
        // also loading site stats
        Report.get(function(success){
            $scope.referrals = success.referrals;
            $scope.counts = success; // counts matrix (invitations, practices, users) x (day, week, ytd)

            $scope.totalItems = success.event_logs.length;
            success.event_logs.forEach(function(item){
                item.event_name = item.type_event.split('_').map(function(item){
                    return item.charAt(0).toUpperCase() + item.slice(1);
                }).join(' ');

                rawEventLogs.push(item);
            });
            
            $scope.onPageUpdate();

            // site stats
            $scope.total_referrals = success.total_referrals;
            $scope.total_active_accounts = success.total_active_accounts;
            $scope.total_active_practices = success.total_active_practices;
        });

    }]);
